import styles from "./ReviewCard.module.css";

export default function ReviewCard({ author, when, text }) {
  return (
    <article className={styles.card}>
      <div className={styles.meta}>
        {author && <span className={styles.author}>{author}</span>}
        {when && <time className={styles.when}>{when}</time>}
      </div>
      <p className={styles.text}>{text}</p>
    </article>
  );
}
